<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="changelog.changelog_title + ' [Changelog] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/changelogs`">
                            <i class="fa fa-code"></i> Changelogs
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ changelog.changelog_title }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>{{ changelog.changelog_title }}</strong>
                            <div class="pull-right" v-if="canEdit">
                                <router-link :to="`/changelogs/email/${changelog.id}`" class="btn btn-sm btn-warning" v-if="!changelog.users_alerted_at">
                                    <i class="fa fa-bell"></i> Email Users
                                </router-link>
                                <router-link :to="`/changelogs/edit/${changelog.id}`" class="btn btn-sm btn-default">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/changelogs/delete/${changelog.id}`" class="btn btn-sm btn-default">
                                    <i class="fa fa-trash"></i> Delete
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Type:</div>
                                <div class="col-md-8">
                                    <label :class="`badge badge-${changelog.label_color}`">{{ changelog.changelog_type_name }}</label>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Released Date:</div>
                                <div class="col-md-8">
                                    <template v-if="changelog.released_at">
                                        {{ changelog.released_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                    </template>
                                </div>
                            </div>
                            <div class="row mb-2" v-if="canEdit">
                                <div class="col text-muted">All Users Were Notified At:</div>
                                <div class="col-md-8">
                                    <template v-if="changelog.users_alerted_at">
                                        {{ changelog.users_alerted_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Details</strong>
                        </div>
                        <div class="card-body">
                            <div v-html="changelog.changelog_description"></div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                userTimezone: this.$store.state.user.timezone,
                id: this.$route.params.id,
                changelog: {},
            }
        },

        computed: {

            canEdit(){
                //Check both
                if(this.$store.state.user.is_admin && this.$store.state.user.is_dev == 1)
                {
                    return true;
                }

                //Default Defense
                return false;
            },

        },

        methods: {

            getChangelog: function() {
                //Get the data
                this.$http
                    .get('/changelogs/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.changelog = response.data.changelog;
                        this.files = response.data.files;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

        },
        mounted() {
            //Get the Changelog
            this.getChangelog();
        }
    }
</script>
